import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation and useNavigate
import Post from "../Post";
import config from "../config";

export default function HomePage() {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Track total pages
  const location = useLocation();
  const navigate = useNavigate(); // Use useNavigate

  useEffect(() => {
    // Get the current page from the URL
    const page = new URLSearchParams(location.search).get("page") || 1;
    setCurrentPage(Number(page));

    // Fetch posts from the backend
    fetch(`${config.apiUrl}/posts?page=${page}`)
      .then((response) => response.json())
      .then(({ posts, pagesTotal }) => {
        // Destructure posts and pagesTotal from response
        setPosts(posts);
        setTotalPages(pagesTotal); // Set total pages from backend
      });
  }, [location.search]); // Re-fetch posts when the URL changes

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/?page=${page}`); // Update the URL to reflect the new page using navigate
  };

  const handleFirstPage = () => {
    handlePageChange(1); // Navigate to the first page
  };

  const handleLastPage = () => {
    handlePageChange(totalPages); // Navigate to the last page
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1); // Navigate to the next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1); // Navigate to the previous page
    }
  };

  return (
    <div className="outlet">
      {posts.length > 0 &&
        posts.map((post) => (
          <Post
            key={post._id} // always provide a unique key when rendering lists
            {...post} // spread the post object to pass each key-value as a prop
          />
        ))}
      <div className="pagination">
        <button onClick={handleFirstPage} disabled={currentPage === 1}>
          &laquo; {/* Double left arrow */}
        </button>
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          &lsaquo; {/* Single left arrow */}
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          &rsaquo; {/* Single right arrow */}
        </button>
        <button onClick={handleLastPage} disabled={currentPage === totalPages}>
          &raquo; {/* Double right arrow */}
        </button>
      </div>
    </div>
  );
}
